module.exports = __webpack_public_path__ + "img/order-instructions.0e945ff7.png";